"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgCap(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M12.266 2.048l.1.046L23.63 8.238l.081.056.074.067.066.078.056.088.043.094.03.098.017.098.003.1-.003.053-.017.099-.03.097-.043.094-.056.088-.084.097-.078.065-.088.056-2.665 1.453v6.156c0 .404-.137.797-.389 1.114-2.162 2.714-5.032 4.086-8.547 4.086-3.514 0-6.385-1.372-8.547-4.086a1.787 1.787 0 01-.38-.941l-.01-.173V11.02L.399 9.566a.766.766 0 01-.1-1.28l.1-.065 11.234-6.127a.766.766 0 01.633-.046zm-7.671 9.806v5.321c0 .058.02.114.056.16 1.87 2.347 4.3 3.508 7.35 3.508 3.049 0 5.477-1.16 7.348-3.509a.256.256 0 00.049-.102l.006-.057v-5.32l-7.037 3.839a.766.766 0 01-.633.046l-.1-.046-7.039-3.84zM12 3.638L2.365 8.894 12 14.148l9.635-5.255L12 3.638z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgCap;
exports.default = _default;